import { render, staticRenderFns } from "./Scores.vue?vue&type=template&id=ff72d4e0&scoped=true&"
import script from "./Scores.vue?vue&type=script&lang=ts&"
export * from "./Scores.vue?vue&type=script&lang=ts&"
import style0 from "./Scores.vue?vue&type=style&index=0&id=ff72d4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff72d4e0",
  null
  
)

export default component.exports